module.exports = __webpack_public_path__ + "static/onion-bread-080ad92cc416b8fea3c6d56cd363a626.jpg";